import useFeatureFlag from '../../hooks/useFeatureFlag'
import { useMutation, useQuery, useQueryClient } from 'react-query'
import { useJobItemsInvalidator } from '../../components/Items/itemQueries'
import { useJobDetailsInvalidator } from '../../components/jobs/jobsQueries'
import { useWorkareaGroupsInvalidator } from '../workareas/groupsQueries'
import { useLegacyJobDataInvalidator } from './jobsQueries'
import { SetJobPricingSettingsRequest, getJobPricingSettings, setJobPricingSettings } from './jobPricingSettingsApi'

const jobPricingSettingsKey = (jobId: number) => ['job-payment-method-pricing', jobId]

export const useJobPricingSettingsQuery = (jobId: number, enabled: boolean) => {
  const isFeatureEnabled = useFeatureFlag('dual-pricing')
  const query = useQuery(jobPricingSettingsKey(jobId), () => getJobPricingSettings(jobId), { enabled: isFeatureEnabled && enabled && jobId > 0 })
  return { ...query, isFeatureEnabled }
}

export const useSetJobPricingSettingsMutation = (jobId: number) => {
  const client = useQueryClient()
  const groups = useWorkareaGroupsInvalidator()
  const items = useJobItemsInvalidator()
  const job = useLegacyJobDataInvalidator()
  const details = useJobDetailsInvalidator()
  return useMutation((request: SetJobPricingSettingsRequest) => setJobPricingSettings(jobId, request), {
    onSuccess: async () => {
      await Promise.all([
        client.invalidateQueries(jobPricingSettingsKey(jobId)),
        groups.invalidateForJob(jobId),
        items.invalidateForJob(jobId),
        job.invalidateForJob(jobId),
        details.invalidateForJob(jobId),
      ])
    },
    // Restrictions can change while this page is open. Refresh the server decision after rejection.
    onError: () => client.invalidateQueries(jobPricingSettingsKey(jobId)),
  })
}
